import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "posAb",
  style: {"top":"3px","left":"30px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`addressbookSearchBox posRe  roomsCategoryTab ${_ctx.rm?.astagsTab?.tab_name == `search` ? `selected fw600` : ``}`),
    style: {"width":"auto"}
  }, [
    (_ctx.searchedDic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/search_icon.png`),
            width: "16",
            height: "17",
            class: "posAb pointer",
            style: {"top":"16px","left":"10px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickSearchIcon && _ctx.clickSearchIcon(...args)))
          }, null, 8, _hoisted_2),
          _createElementVNode("label", {
            class: "dgreyBg fs10 label ml40 mr20 padw3 pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickSearchIcon && _ctx.clickSearchIcon(...args)))
          }, _toDisplayString(_ctx.searchedDic.categoryName) + " | " + _toDisplayString(_ctx.searchedDic.text), 1),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/search_icon.png`),
            width: "16",
            height: "17",
            class: "posAb pointer",
            style: {"top":"11px","left":"10px"}
          }, null, 8, _hoisted_5),
          (_ctx.canSelectShared)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_SelectTag, {
                  name: "searchTypes",
                  id: "searchTypes",
                  class: "fs12",
                  style: {"width":"50px"},
                  options: [`自分`, `共有`],
                  defaultOption: _ctx.searchCategory == `shared` ? `共有` : `自分`,
                  onSelectValue: _ctx.selectSearchType,
                  isDisabled: false,
                  backgroundColor: `rgba(0,0,0,0)`
                }, null, 8, ["defaultOption", "onSelectValue", "backgroundColor"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_TextfieldTag, {
            placeholder: "キーワードを入力",
            style: _normalizeStyle(`height: 34px; min-width: 270px; border-radius: 7px; text-indent: 6em; background: ${
                    _ctx.selectSearchField ? `#fff` : `#eee`
                };`),
            class: "fl fs12 roundForm w100 searchField mt2",
            value: _ctx.searchText,
            onInputValue: _ctx.inputSearchText,
            onClickTextfield: _ctx.clickSearchField,
            onBlur: _ctx.blurSearchField,
            onKeyup: _withKeys(_ctx.startSearch, ["enter","native"])
          }, null, 8, ["style", "value", "onInputValue", "onClickTextfield", "onBlur", "onKeyup"]),
          _hoisted_7
        ])),
    _hoisted_8
  ], 2))
}